import * as React from "react"
const FilterIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={10}
    fill="none"
    {...props}
  >
    <path
      fill="#2FD4CF"
      d="M.133 1.006c1.27 1.619 3.613 4.619 3.613 4.619v3.75c0 .344.283.625.629.625h1.257a.629.629 0 0 0 .628-.625v-3.75s2.338-3 3.607-4.619A.623.623 0 0 0 9.371 0H.629a.623.623 0 0 0-.496 1.006Z"
    />
  </svg>
)
export default FilterIcon
